import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service'; // Import ApiService
import * as CryptoJS from 'crypto-js'; // Import crypto-js

@Component({
  selector: 'app-email-responses',
  standalone: true,
  imports: [],
  templateUrl: './email-responses.component.html',
  styleUrls: ['./email-responses.component.scss']
})
export class EmailResponsesComponent implements OnInit {
  expiry: Date | null = null;
  partner!: string;
  partnerType!: string; // Added partnerType
  project!: string;
  action!: string;
  vendor!: string;
  deliverable!: string;
  message!: string;

  // Action-to-URL maps for customers and vendors
  private customerActionUrlMap: { [key: string]: string } = {
    'plan-acceptance': 'projects/${project}/append?planAccepted=true',
    'toe-acceptance': 'projects/${project}/append?toeAccepted=true',
    'vendor-acceptance': 'projects/${project}/append?vendorAccepted=true',
    'delivery-approval': '/projects/${project}/deliverables/${deliverable}/?status=approved',
    'delivered': 'projects/${project}/append', // Assuming currentDate is a variable holding the current date
    //delivered
  };

  private vendorActionUrlMap: { [key: string]: string } = {
    'toe-acceptance': 'projects/${project}/append?vendorToeAccepted=true',
    'vendor-acceptance': 'projects/${project}/append?vendorAccepted=true',
    'plan-acceptance': 'projects/${project}/append?vendorPlanAccepted=true',
    'role-acceptance': 'projects/${project}/deliverables/${deliverable}/?status=accepted',
    'project-acceptance': 'projects/${project}/deliverables/${deliverable}/?status=accepted',
    'delivery': 'projects/${project}/deliverables/${deliverable}/?status=submitted'
  };

  constructor(private route: ActivatedRoute, private apiService: ApiService) {} // Inject ApiService

  ngOnInit(): void {
    // Parse query string parameters directly
    this.route.queryParams.subscribe((params) => {
      this.expiry = params['expiry'];
      this.partner = params['partner'];
      this.partnerType = params['partnerType']; // Added partnerType
      this.project = params['project'];
      this.action = params['action'];
      this.vendor = params['vendor'];
      this.deliverable = params['deliverable'];

      if(this.expiry != null && this.expiry < new Date()) {
        console.error('Link has expired');
        this.message = 'The link is no longer valid';
        return;
      }

      if (!this.partner || !this.project || !this.action) {
        console.error('Missing required query parameters');
        this.message = 'The link is no longer valid is missing required parameters';
        return;
      }

      // Make an API call with the parsed parameters
      this.makeApiCall();
    });
  }

  makeApiCall(): void {
    // Select the appropriate action-to-URL map based on the partner
    const actionUrlMap =
      this.partner === 'customer'
        ? this.customerActionUrlMap
        : this.partner === 'vendor'
        ? this.vendorActionUrlMap
        : null;

    if (!actionUrlMap) {
      console.error('Unknown partner type:', this.partner);
      return;
    }
  
    let apiUrl = actionUrlMap[this.action]; // Get the URL from the selected map
    if (!apiUrl) {
      console.error('Unknown action:', this.action);
      return;
    }
  
    // Replace placeholders in the URL with actual values
    apiUrl = apiUrl
      .replace('${project}', this.project) // Replace project placeholder
      .replace('${deliverable}', this.deliverable); // Replace deliverable placeholder
  
    let payload: any = {
      vendor: this.vendor
    };
  
    if (this.partner === 'customer') {
      const currentDate = new Date().toISOString();
      
      // First handle customer-specific actions
      if (this.action === 'plan-acceptance') {
        payload.planAcceptedOn = currentDate;
      } 
      else if (this.action === 'toe-acceptance') {
        payload.toeAcceptedOn = currentDate;
      }
      else if (this.action === 'delivered') {
        payload.deliveryDate = currentDate;
      }
      
      // Then handle agency-specific additions
      if (this.partnerType === 'agency') {
        if (this.action === 'vendor-acceptance') {
          payload.vendorPlanAcceptedOn = currentDate;
        }
      }
    }
    // Make the API call using ApiService
    this.apiService.post(apiUrl, payload).subscribe(
      (response) => {
        console.log(`API call for ${this.action} successful:`, response);
      },
      (error) => {
        console.error(`API call for ${this.action} failed:`, error);
      }
    );
  }

  decodeHash(hash: string): any {
    try {
      // Decode the hash (assuming it's Base64 encoded)
      const bytes = CryptoJS.enc.Base64.parse(hash);
      const decodedString = bytes.toString(CryptoJS.enc.Utf8);

      // Parse the decoded string into a JSON object
      return JSON.parse(decodedString);
    } catch (error) {
      console.error('Error decoding hash:', error);
      return null;
    }
  }
}